import { Component, computed, inject, input } from '@angular/core';
import { AdditionalProductsSummaryPoint, Address, IERechnungsInfo, SummaryContractInfo } from '@mwe/models';
import { getAddressGroupFormatted } from '@mwe/utils';
import { BasicCardComponent } from '../../cards/basic-card/basic-card.component';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { InfoboxComponent } from '../../infobox/infobox.component';
import { NewBankAccountInfoTextsComponent } from '../../bank/new-bank-account-info-texts/new-bank-account-info-texts.component';
import { AlertComponent } from '../../alert/alert.component';
import { ProductSummaryContractInfoComponent } from '../products-summary/product-summary-contract-info.component';
import { HeadlineComponent } from '../../headline/headline.component';
import { HeadlineService } from '../../headline/headline.service';
import { SafeHtmlPipe } from '@mwe/ui/pipes';

@Component({
  selector: 'mwe-summary-invoice',
  templateUrl: './summary-invoice.component.html',
  imports: [
    BasicCardComponent,
    TranslateDirective,
    InfoboxComponent,
    NewBankAccountInfoTextsComponent,
    AlertComponent,
    TranslatePipe,
    ProductSummaryContractInfoComponent,
    HeadlineComponent,
    SafeHtmlPipe,
  ],
})
export class SummaryInvoiceComponent {
  cardTitle = input<string>('');
  paymentIcon = input<string>('');
  paymentText = input<string>('');
  paymentInfo? = input<string>('');
  eRechnungInfo = input<IERechnungsInfo>(null);
  invoiceAddress = input<Address>(null);
  invoiceInfoAlertMessage? = input<string>('');
  areBankAccountInfoTextsVisible = input<boolean>(false);
  showBankAccountInfoTextAsAlert = input<boolean>(false);
  productCategories? = input<string[]>();
  additionalBulletPoints? = input<AdditionalProductsSummaryPoint[]>([]);
  hasSpotTariff? = input<boolean>(false);

  emailMessageInfoKey? = input<string>('');
  email? = input<string>('');

  headlineService = inject(HeadlineService);

  contractInfos = input<SummaryContractInfo[]>(null);

  formattedInvoiceAddress = computed<string>(() => {
    return getAddressGroupFormatted(this.invoiceAddress(), true);
  });
}
